import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter as Router} from 'react-router-dom';
import {AuthProvider} from './auth/AuthProvider';

const container = document.getElementById('root');

if (!container) {
    throw new Error('Root element #root not found');
}

const app = (
    <React.StrictMode>
        <Router>
            <AuthProvider>
                <App/>
            </AuthProvider>
        </Router>
    </React.StrictMode>
);

// Prerender leaves HTML in #root; hydrate often mismatches (Helmet, auth). Clear and mount once.
if (container.hasChildNodes()) {
    container.replaceChildren();
}

createRoot(container).render(app);
